import { SignIn, useAuth } from '@clerk/react';
import { CircularProgress, Container, Link, Typography } from '@mui/material';
import { Navigate, useLocation } from 'react-router-dom';
import { hasClerkInvitationTicket } from '../utils/auth';

const LoginPage = () => {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress aria-label="Loading sign in" />
      </div>
    );
  }

  if (isSignedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  if (hasClerkInvitationTicket(location.search, location.hash)) {
    return (
      <Navigate
        to={`/invitation${location.search}${location.hash}`}
        replace
      />
    );
  }

  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: '100vh',
        pt: 14,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h4" align="center" gutterBottom>
        NILUS Dashboard Sign In
      </Typography>
      <Typography color="text.secondary" align="center" sx={{ mb: 3 }}>
        Sign in with your email or assigned username and password.
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <SignIn
          routing="path"
          path="/login"
          forceRedirectUrl="/dashboard"
          fallbackRedirectUrl="/dashboard"
        />
      </div>
      <Typography color="text.secondary" align="center" sx={{ mt: 3 }}>
        Need help signing in?{' '}
        <Link
          href="mailto:info@nilus.eco?subject=NILUS%20Dashboard%20sign-in%20support"
          aria-label="Email NILUS sign-in support at info@nilus.eco"
        >
          Email support
        </Link>
      </Typography>
    </Container>
  );
};

export default LoginPage; 